import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Form } from "react-bootstrap";
import { PrivateRoutes, QueryParamKeys, QueryParamValues, LocalAccountStorage, WelcomeModalType, WelcomeModalStates, AccountRecoveryReminder, useAppSelector } from "src/common";
import welcomeExpressImage from "src/assets/images/welcome-express.svg";

type AllProps = {
  handleShowModal: (modal: WelcomeModalType) => void;
}

function ExpressWelcomeModal(props: AllProps) {
  const { handleShowModal } = props;
  const navigate = useNavigate();
  const current_account = useAppSelector((state) => state.account.current_account);
  const [is_checked, setIsChecked] = useState<boolean>(false);
  // Description: Handle user selection of don't remind me again, save recovery file or close modal.
  // If close modal is clicked, the modal will be closed and the user will not be reminded until next login
  // If save now is selected, the user will be redirected to the password recovery page
  // If in any of the cases above the Don't remind me again checkbox is selected, the user will not be reminded ever again.
  function handleClick(e?: React.MouseEvent) {
    const is_navigate = !!e && e?.currentTarget.id === "navigate";
      if (is_checked && !!current_account) {
        // Note: if don't remind me again is selected, we need to save the user selection along with the user id
        // in localStorage so other users will be reminded.
        const dont_remind_collection = LocalAccountStorage.getAccountRecoveryReminder(AccountRecoveryReminder.EXPRESS_RECOVERY_DO_NOT_REMIND);
        let new_dont_remind_users;

        if (Array.isArray(dont_remind_collection)) {
          // Check if the user is already in the list of users that don't want to be reminded so we don't create duplicates
          new_dont_remind_users = !dont_remind_collection.includes(current_account.user_id) ? [...dont_remind_collection, current_account.user_id] : dont_remind_collection;
        } else {
          new_dont_remind_users = [current_account.user_id];
        }

        LocalAccountStorage.setTemporaryCookies(AccountRecoveryReminder.EXPRESS_RECOVERY_DO_NOT_REMIND, JSON.stringify(new_dont_remind_users));
      } else {
        LocalAccountStorage.setTemporaryCookies(AccountRecoveryReminder.EXPRESS_RECOVERY_REMIND_LATER, "true");
      }
    if (is_navigate) {
      navigate(`/${PrivateRoutes.settings_route}/${PrivateRoutes.password_recovery_route}?${QueryParamKeys.PAGE_ACTION_QUERY_KEY}=${QueryParamValues.save}`);
    } else {
      handleShowModal(WelcomeModalStates.close);
    }
  }
  
  return <>
    <Card.Img variant="top" src={welcomeExpressImage} className="mb-4 welcome-image" />
    <p>
      <b>Please note: </b>We do not store passwords. If you lose your password you can recover your account with your encrypted <b>Account Recovery</b> file.
    </p>
    <p>
      Select the <b className="semi-bold pv-orange">Save Now</b> button to get your Account Recovery file.
    </p>
    <p className="fs-5">
      You will need this file to recover your account and log back into PreVeil.
    </p>

    <Form.Check
      type="checkbox"
      checked={is_checked}
      id="welcome-express-checkbox"
      label="Don't remind me again"
      onChange={() => setIsChecked(!is_checked)} />
    <div className="welcome-buttons">
      <Button id="navigate" variant="primary" className="me-4" onClick={(e) => handleClick(e)}>
        Save now
      </Button>

      <Button
        variant="outline-primary"
        onClick={handleClick}
      >
        Close
      </Button>
    </div>
  </>;
}

export default React.memo(ExpressWelcomeModal);
